import { render, staticRenderFns } from "./howz_table.vue?vue&type=template&id=72947c33&scoped=true"
import script from "./howz_table.vue?vue&type=script&lang=js"
export * from "./howz_table.vue?vue&type=script&lang=js"
import style0 from "./howz_table.vue?vue&type=style&index=0&id=72947c33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72947c33",
  null
  
)

export default component.exports